import each from 'lodash/each';
import get from 'lodash/get';
import { IsNotEmpty, IsOptional, IsString, Matches, Validate, ValidateIf, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import BaseIvrNode from './baseIvrNode';
import { difference, uniqBy } from 'lodash';
import { DomainError } from 'src/models/DomainError';
import { HTTP_METHOD } from './DataDipNodeDef';
import { HttpNodeVariable } from './helpers/HttpNodeVariable';
import { IsUrlOrUrlTemplateValid } from 'src/actions/ivrs/validators/isUrlOrUrlTemplateValidator';
import IvrNode from 'src/models/Ivrs/IvrNode';
import NODE_TYPES from 'src/models/Ivrs/NodeTypes';

export default class Http2Node extends BaseIvrNode {
  @ValidateNested()
  @Type(() => HttpRequestConfig)
  request: HttpRequestConfig;

  credentialId: string;

  @ValidateNested({ each: true })
  @Type(() => HttpNodeVariable)
  variables: HttpNodeVariable[];

  @IsString()
  @IsOptional()
  nextId?: string;

  @IsString()
  @IsOptional()
  errorNodeId?: string;

  timeout: number;
}

class HttpRequestConfig {
  @Validate(IsUrlOrUrlTemplateValid)
  urlTemplate: string;

  @IsString()
  method: string;

  @ValidateNested({ each: true })
  @Type(() => HeaderTemplate)
  headerTemplates: HeaderTemplate[];

  @ValidateIf(props => get(props, 'method') === HTTP_METHOD.POST)
  @IsString()
  contentType: string;

  @ValidateIf(props => get(props, 'method') === HTTP_METHOD.POST)
  bodyTemplate: string;
  ignoreStatusCodes: number[];
}

class HeaderTemplate {
  @Matches(/^[a-zA-Z0-9._-]*$/i, {
    message: 'Please enter a name that consists of letters, numbers, and hyphens with no spaces',
  })
  @IsNotEmpty({ message: 'Please enter a name' })
  name: string;

  @IsString()
  valueTemplate: string;
}

export function validateHeaders(node?: IvrNode): DomainError[] {
  if (node?.type !== NODE_TYPES.IVR_NODE_HTTP2) {
    return [];
  }

  const headers = get(node, 'ivrNode.request.headerTemplates', []) as HeaderTemplate[];
  const nodeId = get(node, 'ivrNode.id');

  const diff = difference(
    headers,
    uniqBy(headers, n => n.name)
  );
  const errors: DomainError[] = [];

  each(diff, (duplicatedHeader: HeaderTemplate) => {
    each(headers, (header: HeaderTemplate, index: number) => {
      if (header.name && header.name === duplicatedHeader.name) {
        errors.push({
          attr: `nodesMap.${nodeId}.ivrNode.request.headerTemplates[${index}].name`,
          code: 'taken',
          detail: 'Please use a unique header name',
        });
      }
    });
  });

  return errors;
}
